const postalCodeValidator = (postalCode) => {
  if (!postalCode || !postalCode.length) {
    return true;
  }
  return /^[0-9]{5}$/.test(postalCode);
};
export {
  postalCodeValidator
};
//# sourceMappingURL=postalCode.es.js.map
